import React from "react";

export const HeartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-suit-heart-fill"
      viewBox="0 0 16 16"
    >
      <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1"></path>
    </svg>
  );
};

export const GroupIcon = () => {
  return (
    <svg width="33" height="27" viewBox="0 0 33 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.9091 17.6667H12.2727C10.7779 17.6667 9.34424 18.252 8.28721 19.2938C7.23019 20.3357 6.63636 21.7488 6.63636 23.2222C6.63636 23.9589 6.93328 24.6655 7.46179 25.1864C7.9903 25.7073 8.70712 26 9.45455 26H23.5455M27.7727 21.8333V17.6667M27.7727 17.6667V13.5M27.7727 17.6667H23.5455M27.7727 17.6667H32M2.40909 24.8848C1.56646 24.4056 1 23.507 1 22.4792C0.999493 21.5037 1.25969 20.5453 1.75443 19.7005C2.24916 18.8557 2.96097 18.1542 3.81818 17.6667M8.04546 1.69444C6.36018 2.65556 5.22727 4.45004 5.22727 6.50698C5.22677 7.48245 5.48697 8.44085 5.9817 9.28569C6.47644 10.1305 7.18824 10.832 8.04546 11.3195M23.5455 6.55556C23.5455 8.02898 22.9516 9.44206 21.8946 10.4839C20.8376 11.5258 19.4039 12.1111 17.9091 12.1111C16.4142 12.1111 14.9806 11.5258 13.9236 10.4839C12.8666 9.44206 12.2727 8.02898 12.2727 6.55556C12.2727 5.08213 12.8666 3.66905 13.9236 2.62718C14.9806 1.58531 16.4142 1 17.9091 1C19.4039 1 20.8376 1.58531 21.8946 2.62718C22.9516 3.66905 23.5455 5.08213 23.5455 6.55556Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UserIcon = () => {
  return (
    <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.2222 16.8333H6.11111C4.75556 16.8333 3.45553 17.3718 2.49701 18.3303C1.53849 19.2889 1 20.5889 1 21.9444C1 22.6222 1.26924 23.2722 1.7485 23.7515C2.22776 24.2308 2.87778 24.5 3.55556 24.5H16.3333M20.1667 20.6667V16.8333M20.1667 16.8333V13M20.1667 16.8333H16.3333M20.1667 16.8333H24M16.3333 6.61111C16.3333 7.96666 15.7948 9.2667 14.8363 10.2252C13.8778 11.1837 12.5778 11.7222 11.2222 11.7222C9.86667 11.7222 8.56664 11.1837 7.60812 10.2252C6.6496 9.2667 6.11111 7.96666 6.11111 6.61111C6.11111 5.25556 6.6496 3.95553 7.60812 2.99701C8.56664 2.03849 9.86667 1.5 11.2222 1.5C12.5778 1.5 13.8778 2.03849 14.8363 2.99701C15.7948 3.95553 16.3333 5.25556 16.3333 6.61111Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ApplicationIcon = () => {
  return (
    <svg width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.7333 25.0667V21.2334M20.7333 21.2334V17.4001M20.7333 21.2334H16.9M20.7333 21.2334H24.5667M1 5.7666C1 4.27327 1 3.52678 1.29067 2.95345C1.54667 2.46012 1.95466 2.04663 2.45599 1.79329C3.02666 1.49996 3.77333 1.5 5.26666 1.5H6.06667C7.56 1.5 8.30667 1.49996 8.87734 1.79329C9.37867 2.04663 9.78666 2.46012 10.0427 2.95345C10.3333 3.52678 10.3333 4.27327 10.3333 5.7666V6.56673C10.3333 8.06007 10.3333 8.80655 10.0427 9.37988C9.78666 9.87322 9.37867 10.2867 8.87734 10.54C8.30667 10.8334 7.56 10.8333 6.06667 10.8333H5.26666C3.77333 10.8333 3.02666 10.8334 2.45599 10.54C1.95466 10.2867 1.54667 9.87322 1.29067 9.37988C1 8.80655 1 8.06007 1 6.56673V5.7666ZM1 20.4333C1 18.9399 1 18.1935 1.29067 17.6201C1.54667 17.1268 1.95466 16.7133 2.45599 16.46C3.02666 16.1666 3.77333 16.1667 5.26666 16.1667H6.06667C7.56 16.1667 8.30667 16.1666 8.87734 16.46C9.37867 16.7133 9.78666 17.1268 10.0427 17.6201C10.3333 18.1935 10.3333 18.9399 10.3333 20.4333V21.2334C10.3333 22.7267 10.3333 23.4732 10.0427 24.0466C9.78666 24.5399 9.37867 24.9534 8.87734 25.2067C8.30667 25.5 7.56 25.5 6.06667 25.5H5.26666C3.77333 25.5 3.02666 25.5 2.45599 25.2067C1.95466 24.9534 1.54667 24.5399 1.29067 24.0466C1 23.4732 1 22.7267 1 21.2334V20.4333ZM15.6667 5.7666C15.6667 4.27327 15.6667 3.52678 15.9573 2.95345C16.2133 2.46012 16.6213 2.04663 17.1227 1.79329C17.6933 1.49996 18.44 1.5 19.9333 1.5H20.7333C22.2267 1.5 22.9733 1.49996 23.544 1.79329C24.0453 2.04663 24.4533 2.46012 24.7093 2.95345C25 3.52678 25 4.27327 25 5.7666V6.56673C25 8.06007 25 8.80655 24.7093 9.37988C24.4533 9.87322 24.0453 10.2867 23.544 10.54C22.9733 10.8334 22.2267 10.8333 20.7333 10.8333H19.9333C18.44 10.8333 17.6933 10.8334 17.1227 10.54C16.6213 10.2867 16.2133 9.87322 15.9573 9.37988C15.6667 8.80655 15.6667 8.06007 15.6667 6.56673V5.7666Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.66667 13H13M1 13H2.818C3.07734 13 3.20734 13 3.32934 12.9733C3.438 12.9466 3.54133 12.9 3.636 12.8467C3.74333 12.78 3.83533 12.6866 4.01867 12.5L12.6673 3.81277C13.0207 3.45942 13.1087 2.91272 12.8393 2.47936C12.5127 1.95143 12.0728 1.5028 11.5513 1.16597C11.3497 1.03695 11.1101 0.980517 10.8721 1.00597C10.634 1.03142 10.4118 1.13721 10.242 1.30595L1.54 10.0465C1.36267 10.2265 1.27467 10.3132 1.21 10.4199C1.15333 10.5132 1.11067 10.6132 1.084 10.7132C1.05333 10.8332 1.05 10.9598 1.044 11.2132L1 13Z"
        stroke="black"
        stroke-opacity="0.5"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RedirectIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.9999 12.8749C20.9999 14.6124 20.9999 15.4875 20.8274 16.2125C20.5582 17.3327 19.9843 18.3564 19.1691 19.1705C18.3539 19.9846 17.3292 20.5572 16.2087 20.8248C15.4899 20.9998 14.6187 20.9999 12.8749 20.9999H10.9999C7.49996 20.9999 5.74996 20.9998 4.41247 20.3248C3.23633 19.7229 2.28043 18.7649 1.68124 17.5874C0.999998 16.2499 1 14.4999 1 10.9999V10.3749C1 7.46246 0.999996 6.01242 1.47624 4.86243C1.78949 4.10304 2.24951 3.41294 2.82994 2.83165C3.41036 2.25037 4.09981 1.78937 4.85873 1.475C5.82872 1.07501 7.01996 1.0125 9.12494 1M20.6999 7.81239C21.0274 5.77491 21.0874 3.71253 20.8774 1.67504C20.8633 1.53329 20.8006 1.40071 20.6999 1.29999M20.6999 1.29999C20.5998 1.19802 20.4661 1.13582 20.3236 1.12497C18.2773 0.914588 16.2122 0.973441 14.1812 1.29999M20.6999 1.29999L8.49995 13.4999"
        stroke="#BEBEBE"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const AngleRight = () => {
  return (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 13C3.17073 11.4322 5.12641 9.5865 6.817 7.51001C6.93534 7.36639 7.00005 7.18609 7.00005 7C7.00005 6.81391 6.93534 6.63361 6.817 6.48999C5.12641 4.4135 3.17073 2.56776 1 1"
        stroke="#303A47"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CheckIcon = () => {
  return (
    <svg width="107" height="107" viewBox="0 0 107 107" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M66.3142 42.6328C67.3638 41.5833 69.0654 41.5833 70.115 42.6328C70.6785 43.1963 70.6785 44.11 70.115 44.6735L49.2539 65.5346C48.4474 66.3411 47.1397 66.3411 46.3332 65.5346C45.5266 64.7281 45.5266 63.4204 46.3332 62.6139L66.3142 42.6328Z"
        fill="#81FE9D"
      />
      <path
        d="M38.4976 57.8601C37.4441 56.8145 37.4378 55.1128 38.4834 54.0593C39.0448 53.4937 39.9584 53.4903 40.524 54.0517L49.1442 62.6078C49.9537 63.4113 49.9586 64.719 49.1551 65.5285C48.3516 66.3381 47.0439 66.3429 46.2344 65.5394L38.4976 57.8601Z"
        fill="#81FE9D"
      />
      <g opacity="0.2" filter="url(#filter0_f_1918_7338)">
        <ellipse cx="53.8632" cy="53.8637" rx="30.1586" ry="30.1586" fill="#81FE9D" />
      </g>
      <defs>
        <filter
          id="filter0_f_1918_7338"
          x="0.757118"
          y="0.757607"
          width="106.212"
          height="106.212"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="11.4737" result="effect1_foregroundBlur_1918_7338" />
        </filter>
      </defs>
    </svg>
  );
};

export const BackArrowIcon = () => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.35833 1C4.60935 2.29326 3.03515 3.80752 1.675 5.505C1.56182 5.64516 1.50006 5.81985 1.5 6M1.5 6C1.50006 6.18015 1.56182 6.35484 1.675 6.49499C3.03515 8.19248 4.60935 9.70674 6.35833 11M1.5 6H16.5"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-x-lg"
      viewBox="0 0 16 16"
    >
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
    </svg>
  );
};

export const CrownIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
      <path
        fill="currentColor"
        d="M7.51 4.87C7.01 6.27 6.45 6.95 5.94 7c-.57.07-1.07-.18-1.54-.8a.54.54 0 0 0-.1-.1 1 1 0 1 0-.8.4l.01.12.82 3.24A1.5 1.5 0 0 0 5.78 11h4.44a1.5 1.5 0 0 0 1.45-1.14l.82-3.24a.54.54 0 0 0 .01-.12 1 1 0 1 0-.8-.4.54.54 0 0 0-.1.09c-.49.62-1 .87-1.54.81-.5-.05-1.04-.74-1.57-2.13a1 1 0 1 0-.98 0zM11 11.75a.5.5 0 1 1 0 1H5a.5.5 0 1 1 0-1h6z"
      />
    </svg>
  );
};

export const RightDragIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-right"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const UpDragIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-up"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
      />
    </svg>
  );
};

export const DownDragIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-down"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
      />
    </svg>
  );
};

export const LeftDragIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-chevron-left"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
      />
    </svg>
  );
};

export const AppArrowIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27.128" height="27.128" viewBox="0 0 27.128 27.128">
      <path
        id="Path_6"
        data-name="Path 6"
        d="M25.433,3.391a1.7,1.7,0,0,0-1.7-1.7H3.391a1.7,1.7,0,0,0-1.7,1.7V23.737a1.7,1.7,0,0,0,1.7,1.7H23.737a1.7,1.7,0,0,0,1.7-1.7ZM0,3.391A3.391,3.391,0,0,1,3.391,0H23.737a3.391,3.391,0,0,1,3.391,3.391V23.737a3.391,3.391,0,0,1-3.391,3.391H3.391A3.391,3.391,0,0,1,0,23.737ZM9.925,18.317a.848.848,0,0,1-1.2-1.2l6.946-6.945H10.978a.848.848,0,0,1,0-1.7h6.74a.848.848,0,0,1,.848.848v6.74a.848.848,0,1,1-1.7,0V11.372Z"
        fill="#fff"
        fillRule="evenodd"
        opacity="0.7"
      />
    </svg>
  );
};

export const DesignationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-person-vcard"
      viewBox="0 0 16 16"
    >
      <path d="M5 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m4-2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M9 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4A.5.5 0 0 1 9 8m1 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5" />
      <path d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zM1 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H8.96q.04-.245.04-.5C9 10.567 7.21 9 5 9c-2.086 0-3.8 1.398-3.984 3.181A1 1 0 0 1 1 12z" />
    </svg>
  );
};

export const UserRoleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-person-fill-gear"
      viewBox="0 0 16 16"
    >
      <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
    </svg>
  );
};

export const FeedbackdataIcon = () => {
  return (
    <svg width="58" height="57" viewBox="0 0 58 57" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3245_10492)">
        <rect x="5.57199" y="2.5" width="46.178" height="45" rx="12" fill="#2F3A79" />
      </g>
      <path
        d="M21.4236 18.3185H35.8542C36.0228 18.3185 36.1912 18.3289 36.3584 18.3497C36.3017 17.962 36.1651 17.5895 35.9567 17.2547C35.7483 16.9199 35.4725 16.6296 35.1458 16.4015C34.8192 16.1733 34.4486 16.012 34.0562 15.9272C33.6639 15.8424 33.258 15.8359 32.8631 15.9081L20.9952 17.8826H20.9817C20.2367 18.0214 19.5743 18.4321 19.1296 19.0309C19.7995 18.5665 20.6015 18.3175 21.4236 18.3185Z"
        fill="white"
      />
      <path
        d="M35.8546 19.375H21.4239C20.6587 19.3758 19.9251 19.6724 19.3841 20.1997C18.843 20.7269 18.5386 21.4418 18.5378 22.1875V30.625C18.5386 31.3707 18.843 32.0856 19.3841 32.6128C19.9251 33.1401 20.6587 33.4367 21.4239 33.4375H35.8546C36.6198 33.4367 37.3534 33.1401 37.8944 32.6128C38.4355 32.0856 38.7398 31.3707 38.7407 30.625V22.1875C38.7398 21.4418 38.4355 20.7269 37.8944 20.1997C37.3534 19.6724 36.6198 19.3758 35.8546 19.375ZM33.7125 27.8125C33.4271 27.8125 33.1481 27.73 32.9108 27.5755C32.6735 27.421 32.4885 27.2014 32.3793 26.9444C32.2701 26.6874 32.2415 26.4047 32.2972 26.1319C32.3529 25.8591 32.4903 25.6085 32.6921 25.4119C32.8939 25.2152 33.1511 25.0813 33.431 25.027C33.7109 24.9728 34.0011 25.0006 34.2648 25.107C34.5284 25.2135 34.7538 25.3937 34.9124 25.625C35.0709 25.8562 35.1556 26.1281 35.1556 26.4062C35.1556 26.7792 35.0035 27.1369 34.7329 27.4006C34.4623 27.6643 34.0952 27.8125 33.7125 27.8125Z"
        fill="white"
      />
      <path
        d="M18.5603 25.1514V20.7788C18.5603 19.8265 19.1014 18.23 20.9797 17.8841C22.5738 17.5928 24.1521 17.5928 24.1521 17.5928C24.1521 17.5928 25.1893 18.2959 24.3325 18.2959C23.4757 18.2959 23.4983 19.3726 24.3325 19.3726C25.1668 19.3726 24.3325 20.4053 24.3325 20.4053L20.9729 24.1187L18.5603 25.1514Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_3245_10492"
          x="0.0719905"
          y="0.5"
          width="57.178"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.5" />
          <feGaussianBlur stdDeviation="2.75" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3245_10492" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3245_10492" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export const CreateNewIcon = () => {
  return (
    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.25 1.06382V2.32001C12.25 4.16801 12.25 5.092 12.6179 5.7982C12.942 6.4187 13.4581 6.92337 14.0928 7.2403C14.815 7.6 15.76 7.6 17.65 7.6H18.9348M12.25 1.06382C11.8068 1.00002 11.278 1 10.3926 1H8.19999C5.67999 1 4.42001 1.00001 3.45701 1.47961C2.6099 1.90088 1.92136 2.57411 1.49051 3.40239C1.00001 4.34399 1 5.57599 1 8.03999V15.96C1 18.424 1.00001 19.656 1.49051 20.5976C1.92136 21.4259 2.6099 22.0991 3.45701 22.5204C4.42001 23 5.67999 23 8.19999 23H11.8C14.32 23 15.58 23 16.543 22.5204C17.3901 22.0991 18.0786 21.4259 18.5095 20.5976C19 19.656 19 18.424 19 15.96V9.4161C19 8.5504 19 8.0334 18.9348 7.6M12.25 1.06382C12.358 1.07922 12.4604 1.09789 12.5616 1.12209C13.0206 1.22989 13.4594 1.40699 13.8621 1.64789C14.3166 1.92069 14.7059 2.3013 15.4844 3.0625L16.8906 4.4375C17.6691 5.1987 18.0584 5.57928 18.3374 6.02368C18.5837 6.41748 18.7649 6.84649 18.8751 7.29529C18.8999 7.39429 18.919 7.4944 18.9348 7.6M10 17.5V14.2M10 14.2V10.9M10 14.2H6.625M10 14.2H13.375"
        stroke="#002200"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const EditiorIcon = () => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.238 17.2048C18.4313 17.2048 18.6167 17.2816 18.7535 17.4183C18.8902 17.555 18.967 17.7404 18.967 17.9338C18.967 18.1271 18.8902 18.3125 18.7535 18.4492C18.6167 18.5859 18.4313 18.6628 18.238 18.6628H11.187C10.9937 18.6628 10.8082 18.5859 10.6715 18.4492C10.5348 18.3125 10.458 18.1271 10.458 17.9338C10.458 17.7404 10.5348 17.555 10.6715 17.4183C10.8082 17.2816 10.9937 17.2048 11.187 17.2048H18.238ZM13.732 0.884766L15.407 2.18475C15.7158 2.37668 15.9835 2.62813 16.1943 2.92444C16.4051 3.22075 16.5549 3.55603 16.635 3.91077C16.7215 4.27312 16.7344 4.64911 16.6729 5.01654C16.6114 5.38397 16.4768 5.73532 16.277 6.04974C16.2723 6.057 16.2673 6.06401 16.2619 6.07074L16.254 6.08075C16.189 6.16775 15.902 6.52875 14.454 8.33875C14.4408 8.36227 14.4258 8.3847 14.409 8.40576C14.3851 8.43719 14.3586 8.46663 14.3299 8.49377L14.018 8.88574L13.7959 9.16278L12.153 11.2197L11.823 11.6328C10.581 13.1878 8.98995 15.1787 6.95195 17.7327C6.73115 18.0074 6.45212 18.2295 6.13493 18.3831C5.81775 18.5367 5.47036 18.6179 5.11797 18.6207L1.58098 18.6658H1.57097C1.40682 18.6656 1.24755 18.6101 1.11876 18.5083C0.989965 18.4065 0.89912 18.2644 0.860947 18.1047L0.0609588 14.7297C-0.0204402 14.3875 -0.022498 14.0311 0.0549774 13.6879C0.132453 13.3447 0.28743 13.0239 0.50798 12.7498L9.66698 1.29578L9.67796 1.28278C10.1687 0.701374 10.867 0.334406 11.6241 0.260071C12.3813 0.185737 13.1376 0.409896 13.732 0.884766ZM8.65495 4.90375L1.65495 13.6578C1.57282 13.7592 1.51508 13.8781 1.48613 14.0053C1.45718 14.1326 1.45779 14.2648 1.48796 14.3917L2.14995 17.1968L5.10497 17.1597C5.24172 17.1591 5.37661 17.1281 5.49992 17.069C5.62323 17.0098 5.73189 16.924 5.81798 16.8177L8.96196 12.8828L9.36699 12.3757L9.77299 11.8677L12.795 8.08478L8.65495 4.90375ZM10.81 2.20978L9.56596 3.76373L13.709 6.94373C14.509 5.94373 15.0309 5.28776 15.0799 5.22376C15.2501 4.92841 15.2996 4.5787 15.2179 4.24774C15.1755 4.06876 15.0975 3.90014 14.9886 3.75189C14.8797 3.60364 14.7421 3.47881 14.584 3.38477C14.515 3.33777 12.877 2.06576 12.826 2.02576C12.5318 1.78869 12.157 1.67532 11.7807 1.70966C11.4045 1.744 11.0564 1.92338 10.81 2.20978Z"
        fill="white"
      />
    </svg>
  );
};

export const ResponseIcon = () => {
  return (
    <svg width="23" height="18" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 17H14C16.8 17 18.2 17 19.27 16.455C20.211 15.976 20.976 15.211 21.455 14.27C22 13.2 22 11.8 22 9C22 7.006 22 5.72202 21.803 4.76202M21.803 4.76202L16.295 8.26703C14.738 9.25703 13.96 9.75298 13.124 9.94598C12.384 10.116 11.616 10.116 10.876 9.94598C10.04 9.75298 9.262 9.25703 7.705 8.26703L3.118 5.34802C2.563 4.99502 2.246 4.31598 2.545 3.72998C3.02402 2.78897 3.78898 2.024 4.73 1.54498C5.8 0.999983 7.2 1 10 1H14C16.8 1 18.2 0.999983 19.27 1.54498C20.211 2.024 20.976 2.78897 21.455 3.72998C21.612 4.03798 21.724 4.37302 21.803 4.76202ZM1 9H2M2 13H7"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const LineIcon = () => {
  return (
    <svg width="2" height="20" viewBox="0 0 2 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="0.998047" y1="2.18561e-08" x2="0.998046" y2="20" stroke="black" stroke-opacity="0.2" />
    </svg>
  );
};

export const UnassignIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.7671 17.833L15.8 15.8M15.8 15.8L17.8329 13.7671M15.8 15.8L13.7671 13.7671M15.8 15.8L17.8329 17.833M1 4.19995C1 3.07995 1 2.52009 1.218 2.09009C1.41 1.72009 1.716 1.40997 2.092 1.21997C2.52 0.999971 3.08 1 4.2 1H4.8C5.92 1 6.48 0.999971 6.908 1.21997C7.284 1.40997 7.59 1.72009 7.782 2.09009C8 2.52009 8 3.07995 8 4.19995V4.80005C8 5.92005 8 6.47991 7.782 6.90991C7.59 7.27991 7.284 7.59003 6.908 7.78003C6.48 8.00003 5.92 8 4.8 8H4.2C3.08 8 2.52 8.00003 2.092 7.78003C1.716 7.59003 1.41 7.27991 1.218 6.90991C1 6.47991 1 5.92005 1 4.80005V4.19995ZM1 15.2C1 14.08 1 13.5201 1.218 13.0901C1.41 12.7201 1.716 12.41 2.092 12.22C2.52 12 3.08 12 4.2 12H4.8C5.92 12 6.48 12 6.908 12.22C7.284 12.41 7.59 12.7201 7.782 13.0901C8 13.5201 8 14.08 8 15.2V15.8C8 16.92 8 17.4799 7.782 17.9099C7.59 18.2799 7.284 18.59 6.908 18.78C6.48 19 5.92 19 4.8 19H4.2C3.08 19 2.52 19 2.092 18.78C1.716 18.59 1.41 18.2799 1.218 17.9099C1 17.4799 1 16.92 1 15.8V15.2ZM12 4.19995C12 3.07995 12 2.52009 12.218 2.09009C12.41 1.72009 12.716 1.40997 13.092 1.21997C13.52 0.999971 14.08 1 15.2 1H15.8C16.92 1 17.48 0.999971 17.908 1.21997C18.284 1.40997 18.59 1.72009 18.782 2.09009C19 2.52009 19 3.07995 19 4.19995V4.80005C19 5.92005 19 6.47991 18.782 6.90991C18.59 7.27991 18.284 7.59003 17.908 7.78003C17.48 8.00003 16.92 8 15.8 8H15.2L13.092 7.78003C13.092 7.78003 12.41 7.27991 12.218 6.90991C12 6.47991 12 5.92005 12 4.80005V4.19995Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const UserSimpleIcon = () => {
  return (
    <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8 5.99922C15.8 7.27226 15.2943 8.49316 14.3941 9.39334C13.494 10.2935 12.2731 10.7992 11 10.7992C9.72698 10.7992 8.50608 10.2935 7.60591 9.39334C6.70573 8.49316 6.20002 7.27226 6.20002 5.99922C6.20002 4.72618 6.70573 3.50528 7.60591 2.6051C8.50608 1.70493 9.72698 1.19922 11 1.19922C12.2731 1.19922 13.494 1.70493 14.3941 2.6051C15.2943 3.50528 15.8 4.72618 15.8 5.99922ZM6.20002 15.5992H15.8C17.0731 15.5992 18.294 16.1049 19.1941 17.0051C20.0943 17.9053 20.6 19.1262 20.6 20.3992C20.6 21.0357 20.3472 21.6462 19.8971 22.0962C19.447 22.5463 18.8365 22.7992 18.2 22.7992H3.80002C3.1635 22.7992 2.55305 22.5463 2.10297 22.0962C1.65288 21.6462 1.40002 21.0357 1.40002 20.3992C1.40002 19.1262 1.90573 17.9053 2.80591 17.0051C3.70608 16.1049 4.92699 15.5992 6.20002 15.5992Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DeleteIcons = () => {
  return (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 5.80377L11.894 3.59277C11.6252 3.05545 11.212 2.60359 10.7009 2.28778C10.1898 1.97197 9.60082 1.80469 9 1.80469C8.39918 1.80469 7.81022 1.97197 7.29909 2.28778C6.78796 2.60359 6.37484 3.05545 6.106 3.59277L5 5.80377M1 5.80377H17M7 10.8038V15.8038M11 10.8038V15.8038M3 5.80377H15V14.8038C15 16.6678 15 17.5998 14.696 18.3348C14.2898 19.3149 13.5111 20.0936 12.531 20.4998C11.796 20.8038 10.864 20.8038 9 20.8038C7.136 20.8038 6.20399 20.8038 5.46899 20.4998C4.48888 20.0936 3.71017 19.3149 3.304 18.3348C3 17.5998 3 16.6678 3 14.8038V5.80377Z"
        stroke="#CA353B"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const RoleInformationIcon = () => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.80149 19H3.26683C2.96928 19.0004 2.67459 18.9404 2.39958 18.8235C2.12457 18.7066 1.87465 18.535 1.66412 18.3186C1.45359 18.1022 1.28656 17.8453 1.17261 17.5624C1.05865 17.2795 1 16.9763 1 16.67C1 14.09 3.02977 12 5.53466 12H7.80149M12.6597 5C12.6597 6.06087 12.2502 7.07822 11.5213 7.82837C10.7925 8.57851 9.80391 9 8.77313 9C7.74235 9 6.75378 8.57851 6.02491 7.82837C5.29604 7.07822 4.88657 6.06087 4.88657 5C4.88657 3.93913 5.29604 2.92178 6.02491 2.17163C6.75378 1.42149 7.74235 1 8.77313 1C9.80391 1 10.7925 1.42149 11.5213 2.17163C12.2502 2.92178 12.6597 3.93913 12.6597 5ZM12.1127 16.5185L13.0843 17.8515L13.0867 17.8548C13.5068 18.4316 13.7173 18.7207 13.9763 18.8235C14.2024 18.9145 14.4536 18.9145 14.6797 18.8235C14.9387 18.7207 15.1492 18.4316 15.5693 17.8548L15.5717 17.8515L16.5433 16.5185C16.794 16.1745 16.9194 16.0025 16.9679 15.8135C17.0107 15.6463 17.0107 15.4706 16.9679 15.3035C16.9194 15.1145 16.794 14.9424 16.5433 14.5984L15.5717 13.2654L15.5693 13.2621C15.1492 12.6853 14.9387 12.3963 14.6797 12.2935C14.4536 12.2024 14.2024 12.2024 13.9763 12.2935C13.7173 12.3963 13.5068 12.6853 13.0867 13.2621L13.0843 13.2654L12.1127 14.5984C11.862 14.9424 11.7366 15.1145 11.6881 15.3035C11.6453 15.4706 11.6453 15.6463 11.6881 15.8135C11.7366 16.0025 11.862 16.1745 12.1127 16.5185Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 1H1V3.89453C1 4.18512 1.11156 4.47593 1.31131 4.6771L7.06369 10.7347C7.26344 10.9358 7.375 11.2266 7.375 11.5172V16.6471L11.625 20V11.5172C11.625 11.2266 11.7366 10.9358 11.9363 10.7347L17.6887 4.6771C17.7875 4.57509 17.866 4.45346 17.9194 4.31911C17.9729 4.18475 18.0003 4.04018 18 3.89453V1Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
};

export const MinusIcon = () => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-q7mezt"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      data-testid="RemoveOutlinedIcon"
    >
      <path d="M19 13H5v-2h14z"></path>
    </svg>
  );
};

export const PLusIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 15V8M8 8V1M8 8H1M8 8H15"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.05025 10.9498L6 6.00008M6 6.00008L10.9497 1.05033M6 6.00008L1.05025 1.05033M6 6.00008L10.9497 10.9498"
        stroke="#2F3A79"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 19L12.95 12.95M12.95 12.95C13.6003 12.3001 14.1161 11.5285 14.4678 10.6791C14.8196 9.8297 15.0004 8.91933 15 8C15 4.13 11.866 1 8 1C4.134 1 1 4.13 1 8C1 11.87 4.134 15 8 15C9.933 15 11.683 14.22 12.95 12.95Z"
        stroke="black"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SideArrow = () => {
  return (
      <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.650024 0.825012H4.25002L10 6.50001L4.25002 12.175H0.650024L6.42502 6.50001L0.650024 0.825012Z" fill="black" fill-opacity="0.7" />
      </svg>
  )
}